import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
    listPropertyResale,
    syncProjectPropertyLinkResale,
} from "../../Redux/Actions/projectResaleActions";

const LinkResaleDropdown = ({ id, projectTypeId, onLinked, linkedProperties = [] }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const { propertyResaleList, listLoading } = useSelector((state) => ({
        propertyResaleList: state.projectResale?.propertyResaleList,
        listLoading: state.projectResale?.listLoading,
    }));

    console.log("Dayaggs", propertyResaleList)

    const [search, setSearch] = useState("");

    const [selectedIds, setSelectedIds] = useState(() =>
        linkedProperties.map((p) => p._id)
    );

    useEffect(() => {
        setSelectedIds(linkedProperties.map((p) => p._id));
    }, [linkedProperties]);

    useEffect(() => {
        if (!id) return;

        dispatch(
            listPropertyResale({
                page: 1,
                limit: 50,
                filter: search,
                project_type: projectTypeId,
                status: ["published"],
                is_deleted: false,
            })
        ).catch(() => {
            toast.error("Failed to load properties");
        });
    }, [dispatch, id, projectTypeId, search]);

    const propertyList = useMemo(() => {
        return propertyResaleList?.data || [];
    }, [propertyResaleList]);

    const toggleSelection = (propertyId) => {
        setSelectedIds((prev) =>
            prev.includes(propertyId)
                ? prev.filter((item) => item !== propertyId)
                : [...prev, propertyId]
        );
    };

    const handleLink = async () => {
        try {
            setSaving(true);
            const res = await dispatch(
                syncProjectPropertyLinkResale({
                    project_id: id,
                    properties_resale: selectedIds,
                })
            );
            if (res?.statusCode === 200) {
                onLinked?.();
            }
        } catch (error) {
            toast.error("Failed to link properties");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="link-rp-wrap">
            <div
                style={{
                    display: "flex",
                    gap: 12,
                    flexWrap: "wrap",
                    alignItems: "center",
                    marginBottom: 14,
                }}
            >
                <input
                    type="text"
                    placeholder="Search by Property ID / address"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                        flex: 1,
                        minWidth: 240,
                        padding: "10px 12px",
                        border: "1px solid #e5e7eb",
                        borderRadius: 10,
                        outline: "none",
                        fontSize: 14,
                    }}
                />

                <button
                    type="button"
                    onClick={handleLink}
                    disabled={saving}
                    style={{
                        padding: "10px 14px",
                        borderRadius: 10,
                        border: "none",
                        background: saving ? "#d1d5db" : "#111827",
                        color: "#fff",
                        fontWeight: 600,
                        cursor: saving ? "not-allowed" : "pointer",
                    }}
                >
                    {saving ? "Saving..." : `Save (${selectedIds.length} selected)`}
                </button>
            </div>

            <div
                style={{
                    maxHeight: 320,
                    overflow: "auto",
                    border: "1px solid #e5e7eb",
                    borderRadius: 12,
                    background: "#fff",
                }}
            >
                {listLoading ? (
                    <div style={{ padding: 16, fontSize: 14 }}>Loading properties...</div>
                ) : propertyList.length === 0 ? (
                    <div style={{ padding: 16, fontSize: 14 }}>No properties found.</div>
                ) : (
                    propertyList.map((item) => {
                        const checked = selectedIds.includes(item._id);

                        return (
                            <label
                                key={item._id}
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 12,
                                    padding: 12,
                                    borderBottom: "1px solid #f3f4f6",
                                    cursor: "pointer",
                                    background: checked ? "#f9fafb" : "#fff",
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={checked}
                                    onChange={() => toggleSelection(item._id)}
                                    style={{ marginTop: 4 }}
                                />

                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 700, fontSize: 14, color: "#111827" }}>
                                        {item.property_id || "N/A"}
                                    </div>

                                    <div style={{ fontSize: 13, color: "#374151", marginTop: 2 }}>
                                        {item.street_address || "No address"}
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 8,
                                            flexWrap: "wrap",
                                            marginTop: 6,
                                        }}
                                    >
                                        {item.project?.project_name && (
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    background: "#eef2ff",
                                                    color: "#3730a3",
                                                }}
                                            >
                                                {item.project.project_name}
                                            </span>
                                        )}

                                        {item.city?.city_name && (
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    background: "#ecfeff",
                                                    color: "#155e75",
                                                }}
                                            >
                                                {item.city.city_name}
                                            </span>
                                        )}

                                        {item.status && (
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    background: "#f3f4f6",
                                                    color: "#374151",
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                {item.status}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </label>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default LinkResaleDropdown;